import { Button, Card, Col, Divider, Row, Tag, Typography } from "antd";
import React, { useEffect } from "react";
import { EyeOutlined, FileOutlined } from "@ant-design/icons";
import HeadingAndText from "../../../components/HeadingAndText";
import { useDispatch } from "react-redux";
import { getData } from "../../../actions/apiCall";
import { constants } from "../../../constants/common";
const { Text, Title } = Typography;

const FinanceSummary = () => {
    const [financeData, setFinanceData] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        getFinanceSummary();
    }, []);


    const getFinanceSummary = async () => {
        setLoading(true);
        setFinanceData(null);
        try {
            const resData = await dispatch(getData('/finance/my-finance'));
            if (resData.code === 200) {
                setFinanceData(resData.data);
            }

        } catch (error) {
            console.error("Error fetching finance summary:", error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            {!financeData && !loading && <Card>You don't have access to this page at the moment.</Card>}
            {loading && <Card loading={true} style={{ height: '100vh' }} />}
            {financeData && (<>
                <Card title={<Title level={5}>Payment Information</Title>} bordered={false} style={{ marginBottom: '20px' }}>
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <HeadingAndText heading={'Salary Payment Mode'} text={'Bank Transfer'} />
                        </Col>
                        <Col span={24}>
                            <Divider orientation="left">Bank Information</Divider>
                        </Col>
                        <Col span={6}>
                            <HeadingAndText heading={'Bank'} text={financeData?.bankName} />
                        </Col>
                        <Col span={6}>
                            <HeadingAndText heading={'Account Number'} text={financeData?.accountNumber} />
                        </Col>
                        <Col span={6}>
                            <HeadingAndText heading={'IFSC Code'} text={financeData?.ifscCode} />
                        </Col>
                        <Col span={6}>
                            <HeadingAndText heading={'Name on the Account'} text={constants.GET_FULL_NAME(financeData?.employee)} />
                        </Col>
                    </Row>
                </Card>

                <Card title={<Title level={5}>Identity Information</Title>} bordered={false} style={{ marginBottom: '20px' }}>
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Tag icon={<FileOutlined />} color="success">
                                PAN Card VERIFIED
                            </Tag>
                        </Col>
                        <Col span={6}>
                            <HeadingAndText heading={'Permanent Account Number'} text={financeData?.panNumber} />
                            {/* <Button type="link" icon={<EyeOutlined />} /> */}
                        </Col>
                        <Col span={6}>
                            <HeadingAndText heading={'UAN Number'} text={financeData?.uanNumber} />
                        </Col>
                        {/* <Col span={6}>
                            <HeadingAndText heading={'Date of Birth'} text={financeData?.dateOfBirth} />
                        </Col>
                        <Col span={6}>
                            <HeadingAndText heading={`Parent's Spouse's Name`} text={financeData?.spouseName} />
                        </Col>
                        <Col span={24}>
                            <Text strong>Photo ID</Text>
                            <Divider type="vertical" />
                            <Text strong>Address Proof</Text>
                            <Button type="link" icon={<FileOutlined />} style={{ marginLeft: '10px' }}>
                                1 file(s)
                            </Button>
                        </Col> */}
                    </Row>
                </Card>

                <Card title={<Title level={5}>Statutory Information</Title>} bordered={false}>
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Text strong>PT Details</Text>
                        </Col>
                        <Col span={12}>
                            <HeadingAndText heading={'Charges'} text={'200 - 300'} />
                        </Col>
                        <Col span={12}>
                            {/* <HeadingAndText heading={'Registered Location'} text={'Hyderabad'} /> */}
                        </Col>
                    </Row>
                </Card>
            </>)}

        </>
    )
}

export default FinanceSummary;